import { authRequest } from "./AjaxService";
import { IDeliveryBoard, IDeliveryBoardItem, IDeliveryDriver, IDeliverySettlementGroup, IResponse } from "../common/interfaces";

// Tablero de domicilios: rutas /api/deliveries/* del back (spa.auth + permisos domicilios.*).
type TResponse<T> = IResponse<T> & { status?: number };

export const DeliveryBoardService = {
  getBoard: (warehouseId: number): Promise<TResponse<IDeliveryBoard>> =>
    authRequest.get("deliveries/board", { warehouse_id: warehouseId }),
  getDrivers: (warehouseId: number): Promise<TResponse<IDeliveryDriver[]>> =>
    authRequest.get("deliveries/drivers", { warehouse_id: warehouseId }),
  assign: (id: number, driverId: number): Promise<TResponse<IDeliveryBoardItem>> =>
    authRequest.post(`deliveries/${id}/assign`, { driver_id: driverId }),
  resolve: (id: number, action: "retry" | "pool" | "cancel"): Promise<TResponse<IDeliveryBoardItem>> =>
    authRequest.post(`deliveries/${id}/resolve`, { action }),
  manualDeliver: (id: number): Promise<TResponse<IDeliveryBoardItem>> =>
    authRequest.post(`deliveries/${id}/manual-deliver`),
  photoUrl: (eventId: number): Promise<TResponse<{ url: string }>> =>
    authRequest.get(`deliveries/events/${eventId}/photo`),
  getSettlement: (warehouseId: number): Promise<TResponse<IDeliverySettlementGroup[]>> =>
    authRequest.get("deliveries/settlement", { warehouse_id: warehouseId }),
  settle: (payload: { driver_id: number; delivery_ids: number[]; counted: number; cash_box_id: number }):
    Promise<TResponse<{ expected: number; counted: number; difference: number; settled: number[] }>> =>
    authRequest.post("deliveries/settlement", payload),
  broadcastAuthEndpoint: `${process.env.REACT_APP_API_URL}deliveries/broadcasting/auth`,
};
